let state = {
  mailInfo: [] // 查询得到的邮件数据
}
let mutations = {
  setMailInfo (state, data) {
    state.mailInfo = data
  }
}
export default { mutations, state, namespaced: true }
